module.exports = __webpack_public_path__ + "img/Free Computer Image on Unsplash.45575d7b.png";